import moment from "moment-timezone";
import CommonHelper from "./CommonHelper";

/*
 * Gets an alphabetized String from the given input
 */
function getAlphabetizedString(input) {
  var returnValue = "";

  if (input !== undefined && input !== "") {
    var inputArray = input.split(",");

    returnValue = inputArray.sort().join(", ");
  }

  return returnValue;
}

function convertTimeToHST(inputTime) {
  var dateObj = new Date(inputTime);
  return inputTime ? moment(dateObj).tz('Pacific/Honolulu').format('ddd, MMM DD YYYY, HH:mm:ss z') : "";
}

/*
 * Sort Function for q-table
 */
function customSort(rows, sortBy, descending) {
  const data = [...rows]

  if (sortBy) {
    data.sort((a, b) => {
      const x = descending ? b : a
      const y = descending ? a : b

      if (sortBy === 'changed_date' || sortBy === 'last_active' || sortBy === 'last_changed_date') {
        // date sort
        const dateX = x[ sortBy ] ? moment(x[ sortBy ], 'ddd, MMM DD YYYY, HH:mm:ss z').toDate() : new Date(null);
        const dateY = y[ sortBy ] ? moment(y[ sortBy ], 'ddd, MMM DD YYYY, HH:mm:ss z').toDate() : new Date(null);
        return dateX > dateY ? 1 : dateX < dateY ? -1 : 0
      } else {
        // string sort
        return x[ sortBy ] > y[ sortBy ] ? 1 : x[ sortBy ] < y[ sortBy ] ? -1 : 0
      }
    })
  }

  return data;
}

function toggleNoScopeFilter(filter, noScopeFilter) {
  filter.value = noScopeFilter.value ? "noScope" : "";
}

function customFilter(rows, filter, noScopeFilter) {
  let filteredRows = rows;

  if (filter.value === "noScope" && noScopeFilter !== null && noScopeFilter.value) {
    // Filter to only no Scope users
    filteredRows = rows.filter(row => row["scopes"] === "" && (row["user_groups"] === undefined || row["user_groups"] === ""));
  } else if (filter.value !== "") {
    // Default filter; searches on all columns
    if (noScopeFilter !== null) {
      // admin rows
      filteredRows = rows.filter(
        row => Object.keys(row).some(key => row[key] != undefined && row[key].toLowerCase().includes(filter.value.toLowerCase()))
      );
    } else {
      // log rows
      filteredRows = rows.filter(
        row => Object.keys(row).some(key => key.toLowerCase().includes(filter.value.toLowerCase()) || (row[key] != undefined && row[key].toLowerCase().includes(filter.value.toLowerCase())))
      );
    }
  }

  return filteredRows
}

let userGroupsList = await CommonHelper.getUserGroups(false);

function getLogChanges(log) {
  let returnValue = [];
  
  switch (log["type"]) {
    case "Add":
      Object.keys(log).sort().forEach((key) => {
        if (key.endsWith("_new")) {
          let field = key.substring(0, key.length - 4);

          if (field === "accessLevel" || field === "emails" || field === "scopesAccess") {
            returnValue.push(`${field}:`);

            log[key].split(",").sort().forEach((value) => {
              returnValue.push(value);
            })
          } else if (field === "location_id") {
            returnValue.push(`location_id: "${CommonHelper.getSchoolNameArray(log[key]).join("; ")}"`);
          } else if (field === "action_category" || field === "island") {
            // multiple dropdown select
            returnValue.push(`${field}: "${log[key].split(":::").join("; ")}"`);
          } else if (field === "access_user_group_uid") {
            let userGroupArray = [];
            log[key].split(":::").forEach((logUserGroupUid) => {
              const selectedUserGroup = userGroupsList.find((userGroup) => {
                return userGroup.uid === logUserGroupUid;
              });
              if (selectedUserGroup === undefined) {
                userGroupArray.push(logUserGroupUid);
              } else {
                userGroupArray.push(selectedUserGroup.name);
              }
            });
            returnValue.push(`access_user_group_uid: "${userGroupArray.sort().join(", ")}"`);
          } else {
            returnValue.push(`${field}: "${log[key]}"`);
          }
        }
      })
      break;
    case "Delete":
      Object.keys(log).sort().forEach((key) => {
        if (key.endsWith("_old")) {
          let field = key.substring(0, key.length - 4);

          if (field === "accessLevel" || field === "emails" || field === "scopesAccess") {
            returnValue.push(`${field}:`);

            log[key].split(",").sort().forEach((value) => {
              returnValue.push(value);
            })
          } else if (field === "location_id") {
            returnValue.push(`location_id: "${CommonHelper.getSchoolNameArray(log[key]).join("; ")}"`);
          } else if (field === "action_category" || field === "island") {
            // multiple dropdown select
            returnValue.push(`${field}: "${log[key].split(":::").join("; ")}"`);
          } else if (field === "access_user_group_uid") {
            let userGroupArray = [];
            log[key].split(":::").forEach((logUserGroupUid) => {
              const selectedUserGroup = userGroupsList.find((userGroup) => {
                return userGroup.uid === logUserGroupUid;
              });
              if (selectedUserGroup === undefined) {
                userGroupArray.push(logUserGroupUid);
              } else {
                userGroupArray.push(selectedUserGroup.name);
              }
            });
            returnValue.push(`access_user_group_uid: "${userGroupArray.sort().join(", ")}"`);
          } else {
            returnValue.push(`${field}: "${log[key]}"`);
          }
        }
      })
      break;
    case "Update":
      Object.keys(log).sort().forEach((key) => {
        if (key.endsWith("_new")) {
          let field = key.substring(0, key.length - 4);
          let oldValue = log[`${field}_old`] !== undefined ? log[`${field}_old`] : "";
          let newValue = log[key];

          if (field === "accessLevel" || field === "emails" || field === "scopesAccess") {
            returnValue.push(`${field}:`);

            getLogChangesCommaDelineated(oldValue, newValue).sort().forEach((value) => {
              returnValue.push(value);
            })
          } else if (field === "location_id") {
            returnValue.push(`location_id: "${CommonHelper.getSchoolNameArray(oldValue).join("; ")}" to "${CommonHelper.getSchoolNameArray(newValue).join("; ")}"`);
          } else if (field === "action_category" || field === "island") {
            // multiple dropdown select
            returnValue.push(`${field}: "${oldValue.split(":::").join("; ")}" to "${newValue.split(":::").join("; ")}"`);
          } else if (field === "access_user_group_uid") {
            let oldUserGroupArray = [];
            let newUserGroupArray = [];
            oldValue.split(":::").forEach((logUserGroupUid) => {
              const selectedUserGroup = userGroupsList.find((userGroup) => {
                return userGroup.uid === logUserGroupUid;
              });
              if (selectedUserGroup === undefined) {
                oldUserGroupArray.push(logUserGroupUid);
              } else {
                oldUserGroupArray.push(selectedUserGroup.name);
              }
            });

            newValue.split(":::").forEach((logUserGroupUid) => {
              const selectedUserGroup = userGroupsList.find((userGroup) => {
                return userGroup.uid === logUserGroupUid;
              });
              if (selectedUserGroup === undefined) {
                newUserGroupArray.push(logUserGroupUid);
              } else {
                newUserGroupArray.push(selectedUserGroup.name);
              }
            });
            returnValue.push(`access_user_group_uid: "${oldUserGroupArray.sort().join(", ")}" to "${newUserGroupArray.sort().join(", ")}"`);
          } else {
            returnValue.push(`${field}: "${oldValue}" to "${newValue}"`);
          }
        } else if (key === "file_deleted" || key === "file_replaced" || key === "filename") {
          returnValue.push(`${key}: ${log[key]}`);
        }
      })
      break;
  }

  return returnValue;
}

function getLogChangesCommaDelineated(oldValue, newValue) {
  let returnValue = [];

  const oldValueArray = oldValue !== "" ? oldValue.split(",") : [];
  const newValueArray = newValue !== "" ? newValue.split(",") : [];

  oldValueArray.forEach((value) => {
    if (!newValueArray.includes(value)) {
      returnValue.push(`${value} - removed`);
    } else {
      returnValue.push(value);
    }
  })

  newValueArray.forEach((value) => {
    if (!oldValueArray.includes(value)) {
      returnValue.push(`${value} - added`);
    }
  })

  return returnValue;
}

export default {
  //functions
  getAlphabetizedString,
  convertTimeToHST,
  customSort,
  toggleNoScopeFilter,
  customFilter,
  getLogChanges
};